import React, { Component, Fragment } from 'react';
import intl from 'react-intl-universal';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';


class EditUserMe extends Component {

  constructor(props) {
    super(props);

    this.state = {
      userID: this.props.edituserdata.id,
      firstName: this.props.edituserdata.firstName,
      lastName: this.props.edituserdata.lastName,
      description: this.props.edituserdata.description
    }
}

handleChange(e) {
  this.setState({
    [e.target.name]: e.target.value
  })
}

submitupdateuser = (event) =>{  
  event.preventDefault()
 
  let jsonfields= "";
  jsonfields += '"firstName": "' + event.currentTarget.firstName.value + '",';
  jsonfields += '"lastName": "' + event.currentTarget.lastName.value + '",';
  jsonfields += '"description": "' + event.currentTarget.description.value + '"';

  let json = "";
  json = '{';
  json += jsonfields;
  json += '}';

  console.log(json)
  this.updateuser(this.props.token,json)

}

updateuser (token,json)  {
  let apiurl = window.apiurl
  console.log(json)
  fetch("https://"+apiurl+"/api/User/me", {
      method: 'PUT',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token,
      },
      body: json
    })
      .then(res => res.json())
      .then(json => {
        console.log("---------------")
        console.log(json)
        console.log("---------------")
        this.props.closedit()
      })
      .catch(function(error) {
          console.log(error.status);
        });         
    }

    render () {  
        
       console.log (this.state)
      
      
        
      return (
          <Fragment>
          <Container maxWidth="sm">
          <CloseIcon onClick={()=>this.props.closedit()} />

          <Typography variant="h6" gutterBottom>
          {intl.get('ACCOUNT_EDIT_USER')}:  <span class="small1">( {intl.get('ACCOUNT_EDIT_USER_NO')} )</span>
 </Typography>

   

<Box component="form" onSubmit={this.submitupdateuser}  Validate >
 <Grid container spacing={3}>
   <Grid item xs={12}>
     <TextField
       required
       id="firstName"
       name="firstName"
       label={intl.get('ACCOUNT_EDIT_FORM_VORNAME')}
       value={this.state.firstName}   
       //onChange={(e) => this.handleChange(e)}
       fullWidth
       variant="standard"
     />
   </Grid>
   <Grid item xs={12}>
     <TextField
       required
       id="lastName"
       name="lastName"
       label={intl.get('ACCOUNT_EDIT_FORM_NACHNAME')}
       value={this.state.lastName} 
       //onChange={(e) => this.handleChange(e)}
       fullWidth
       variant="standard"
     />
   </Grid>
   <Grid item xs={12}>
     <TextField
       required
       id="description"
       name="description"
       label={intl.get('ACCOUNT_EDIT_FORM_BESCHREIBUNG')}
       value={this.state.description}
       onChange={(e) => this.handleChange(e)}
       multiline
       rows={4}
       fullWidth
       variant="standard"
     />
   </Grid>
   
       <Grid item xs={12}>
       <Button
       type="submit"
       fullWidth
       variant="contained"
       sx={{ mt: 3, mb: 2 }}
     >
       {intl.get('ACCOUNT_EDIT_FORM_SUBMIT_USER')}
     </Button>
     </Grid>

 </Grid>
 </Box>
 
 </Container>
 </Fragment> 
        )
    }
}


export default EditUserMe;